<template>
  <div class="teaching-video">
    <el-tabs v-model="activeName">
      <el-tab-pane label="视频学习" name="videoLearning">
        <videoLearning @showDialog="showDialog" />
      </el-tab-pane>
      <el-tab-pane label="考前教学" name="teaching">
        <teaching @showDialog="showDialog" />
      </el-tab-pane>
    </el-tabs>
    <el-dialog custom-class="dailogComponents" title="查看视频" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="800px">
      <el-row type="flex" class="dialog-video-box dialogBox" justify="space-around">
        <video-player :class="getVideoClass" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions" @ready="playerIsReady"></video-player>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import videoLearning from "@/views/admin/information/teachingVideo/videoLearning"; //视频学习
import teaching from "@/views/admin/information/teachingVideo/teaching"; //考前教学
import * as videojs from 'video.js'
import 'videojs-flash'
import 'videojs-hotkeys'

export default {
  name: "teachingVideo",
  components:{
    videoLearning,
    teaching,
  },
  data(){
    return{
      activeName:'videoLearning',
      visible: false,
      playerOptions: {
        muted: false,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            src: "",
            type: "",
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请联系管理员！",
        poster: "../../../assets/img/video.png", //你的封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      videoRotate: 0,
    }
  },
  computed:{
    getVideoClass() {
      return ['', 'videos-rotate1', 'videos-rotate2', 'videos-rotate3'][this.videoRotate]
    },
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  methods:{
    showDialog(item){
      this.visible = true;
      let path = item.url;
      let videoType = path.substring(path.lastIndexOf(".") + 1)
      console.log(videoType)
      if ( videoType=== "mp4" || videoType=== 'MP4') {
        this.playerOptions.sources[0].type = "video/mp4";
      }
      else {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      }
      this.playerOptions.sources[0].src = item.url;
      this.$nextTick(() => {
        this.createBut()
      })
    },
    createBut() {
      let Button = videojs.getComponent('Button')
      let myButton = videojs.extend(Button, {
        constructor: function (player, options) {
          Button.apply(this, arguments)
          this.addClass('fullscreen-enter')
        },
        handleClick: () => {
          // 绑定点击事件
          this.videoRotate = this.videoRotate == 3 ? 0 : this.videoRotate + 1
        },
        buildCSSClass: function () {
          return 'iconfont pro-icon-xuanzhuan video-player-button'
        }
      })
      //注册
      videojs.registerComponent('myButton', myButton)
      // 添加到controlBar中
      this.$refs.videoPlayer.player.getChild('controlBar').addChild('myButton')
    },
    playerIsReady(player) {
      console.log('example 2 ready!', player)
      player.hotkeys({
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
        fullscreenKey: function (event, player) {
          // override fullscreen to trigger when pressing the F key or Ctrl+Enter
          return ((event.which === 70) || (event.ctrlKey && event.which === 13));
        }
      })
    },
  }
}
</script>
<style lang="scss">
.teaching-video{
  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }
  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }
  .video-player {
    padding: 0px 20px;
    width: calc(100% - 40px);
    .video-js {
      width: 100%;
      overflow: hidden;
      height: 700px;
    }
  }
  .videos-rotate1 {
    .vjs-tech {
      transform: rotateZ(-90deg);
    }
  }
  .videos-rotate2 {
    .vjs-tech {
      transform: rotateZ(-180deg);
    }
  }
  .videos-rotate3 {
    .vjs-tech {
      transform: rotateZ(-270deg);
    }
  }
}
</style>